/* Product specifications and palette expansion. Inline sizing: ivellora-custom-size-v18.js. */
(() => {
  const expandedPalettes = new Map();
  const keyOf = picker => `${picker.dataset.sectionId}:${picker.dataset.productId}`;
  function initialize() {
    // Format existing "Label: value" product specifications without inventing data.
    document.querySelectorAll('.iv-product-copy ul').forEach(list => {
      const items = [...list.children];
      if (items.length < 2 || !items.every(item => item.tagName === 'LI' && !item.querySelector('a, ul, ol') && item.textContent.includes(':'))) return;
      const table = document.createElement('table');
      table.className = 'iv-detail-table';
      const caption = document.createElement('caption');
      caption.className = 'visually-hidden'; caption.textContent = 'Product specifications'; table.append(caption);
      const body = document.createElement('tbody');
      items.forEach(item => {
        const text = item.textContent.trim(), split = text.indexOf(':');
        const row = document.createElement('tr'), label = document.createElement('th'), value = document.createElement('td');
        label.scope = 'row'; label.textContent = text.slice(0, split).trim(); value.textContent = text.slice(split + 1).trim();
        row.append(label, value); body.append(row);
      });
      table.append(body); list.replaceWith(table);
    });
  }
  document.addEventListener('click', event => {
    const button = event.target.closest?.('[data-ivellora-color-toggle]');
    const picker = button?.closest('variant-picker');
    if (!picker) return;
    const palette = button.closest('.variant-option--yuanqi-color');
    const expanded = palette.classList.toggle('ivellora-color-palette--expanded');
    expandedPalettes.set(keyOf(picker), expanded);
    button.setAttribute('aria-expanded', String(expanded));
    button.textContent = expanded ? 'Show fewer colors' : `View all ${button.dataset.totalColors} colors`;
  });
  let queued = false;
  new MutationObserver(records => {
    if (queued || !records.some(record => [...record.addedNodes].some(node => node instanceof Element && (node.matches('variant-picker, .iv-product-copy') || node.querySelector('variant-picker, .iv-product-copy'))))) return;
    queued = true;
    queueMicrotask(() => { queued = false; initialize(); });
  }).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
  initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('ivellora:variant-picker-updated', () => {
    document.querySelectorAll('variant-picker').forEach(picker => {
      const palette = picker.querySelector('.variant-option--yuanqi-color');
      if (!palette) return;
      const expanded = expandedPalettes.get(keyOf(picker)) === true;
      palette.classList.toggle('ivellora-color-palette--expanded', expanded);
      const toggle = palette.querySelector('[data-ivellora-color-toggle]');
      if (toggle) {
        toggle.setAttribute('aria-expanded', String(expanded));
        toggle.textContent = expanded ? 'Show fewer colors' : `View all ${toggle.dataset.totalColors} colors`;
      }
    });
    initialize();
  });
})();
